import { useApolloClient } from '@vue/apollo-composable';

import { useReferentialStore } from '../store';

import type { Currency } from '~~/domains/graphql';

const ENNISMORE_SUPPORTED_CURRENCIES = [
  'EUR',
  'GBP',
  'USD',
  'AED',
  'SAR',
  'TRY',
  'QAR',
  'CNY',
  'JPY',
  'KRW',
  'THB',
  'VND',
  'INR',
  'PLN',
  'DKK',
  'ILS',
  'KZT',
  'UAH',
  'RUB',
  'EGP',
  'CHF',
  'CAD',
  'AUD',
  'MXN',
  'ZAR',
];

export async function usePreloadCurrencies() {
  const store = useReferentialStore();
  const { client } = useApolloClient();

  if (!store._currencies?.length) {
    await store.fetchCurrencies(client);
  }
}

export function useCurrencies() {
  const store = useReferentialStore();
  const { client } = useApolloClient();

  if (!store._currencies?.length) {
    store.fetchCurrencies(client);
  }

  return computed(() => {
    const allCurrencies = store.currencies ?? [];
    return allCurrencies.filter(currency =>
      ENNISMORE_SUPPORTED_CURRENCIES.includes(currency.code),
    );
  });
}

export function useCurrenciesMap() {
  const currencies = useCurrencies();

  return computed(() =>
    currencies.value.reduce(
      (acc, currency) => ({ ...acc, [currency.code]: currency }),
      {} as Record<Currency['code'] | string, Currency>,
    ),
  );
}
